import { checkMutationAccess, applyRowAccess } from './chunk-LPUBGPML.js';
import { personaFromIdentityRow } from '@almadar/core';
import { entityAccessPoliciesByStoreKey } from '@almadar/core/mock';

function installPolicyOwnerGates(adapter, schema, viewer) {
  const policiesByStore = entityAccessPoliciesByStoreKey(schema);
  adapter.setOwnerGate((storeKey, candidateRow) => {
    const user = viewer();
    if (!user) return true;
    return checkMutationAccess(candidateRow, policiesByStore.get(storeKey)?.create, { user });
  });
  adapter.setOwnerCandidateGate((storeKey, candidateRow, candidateIdentityRow) => {
    const persona = personaFromIdentityRow(candidateIdentityRow);
    if (!persona) return false;
    return checkMutationAccess(candidateRow, policiesByStore.get(storeKey)?.create, { user: persona });
  });
  adapter.setOwnerReadGate((storeKey, candidateRow, candidateIdentityRow) => {
    const read = policiesByStore.get(storeKey)?.read;
    const persona = personaFromIdentityRow(candidateIdentityRow);
    if (read === void 0 || !persona) return false;
    return applyRowAccess([candidateRow], read, void 0, { user: persona }).length === 1;
  });
}

export { installPolicyOwnerGates };
